import React from "react";
import styled from "styled-components";
interface Props {
  label: string;
  isSelected: boolean;
  onChange: (e: React.ChangeEvent) => void;
  disabled?: boolean;
}

const RadioButtonContainer = styled.div`
  padding: 20px;
`;

const RadioButton = ({ label, isSelected, onChange, disabled }: Props) => (
  <RadioButtonContainer>
    <label>
      <input
        type="radio"
        name={label}
        checked={isSelected}
        onChange={onChange}
        disabled={disabled}
      />
      {label}
    </label>
  </RadioButtonContainer>
);

export default RadioButton;
